export const average = (array) => {
    let avg = null;

    if (array && array.length > 0) {
        let sum = array.reduce((sum, value) => {
            return sum + value;
        }, 0);

        avg = sum / array.length;
    }

    return avg;
};

/**
 * @param {array} array
 * returns an object results that contains the average and the standard deviation
 */
export const standardDeviation = (array) => {
    let results = {
        avg: null,
        stdev: null
    };

    if (array && array.length > 0) {
        results.avg = average(array);

        let sqDiffs = array.map((value) => {
            let diff = value - results.avg;
            let sqDiff = diff * diff;

            return sqDiff;
        });

        let variance = average(sqDiffs);
        results.stdev = Math.sqrt(variance);
    }

    return results;
};

export const groupBy = (array, func) => {
    return array.reduce((initialVal, currentVal) => {
        let key = func(currentVal);

        // If the key doesn't exist yet, create it
        if (!initialVal.hasOwnProperty(key)) {
            initialVal[key] = [];
        }

        // Push the value to the object
        initialVal[key].push(currentVal);

        return initialVal;
    }, {});
};

// Remove duplicates that have the same value on the provided object key
// or on the element itself if no object key is provided
export const removeDuplicates = (originalArray, objKey) => {
    let trimmedArray = [];
    let values = [];
    let value;

    for (let i = 0, len = originalArray.length; i < len; i++) {
        value = objKey ? originalArray[i][objKey] : originalArray[i];

        if (values.indexOf(value) === -1) {
            trimmedArray.push(originalArray[i]);
            values.push(value);
        }
    }

    return trimmedArray;
};

//reorder an element in the array based on the from and to indices in the arr.
export const reorderArray = (array, from, to) => {
    return array.splice(to, 0, array.splice(from, 1)[0]);
};
